import { TaskData } from "../../../components/workflow/workflowData"
import { getDateFormat, getUserData, isEmpty, updateNotificationRuleActions, decodeHtmlEntities } from "../../../utility/Utils"
import { GetIndexValueFromWorkflowData, GetIdOfNodeFromObject } from "../../../utility/WorkflowUtilities"
import { v4 as uuidv4 } from 'uuid'
import { CHANGE_TASK_STATUS, RESET_TEMPLATE_BRANCH_AND_COMPANY, RESTORE_TEMPLATE_BRANCH_AND_COMPANY, UPDATE_TEMPLATE_BRANCH_AND_COMPANY } from "../../types/template"
import moment from "moment"

// ** Initial State
const initialState = {
  initialWorkflow: null,
  workflowItems: [],
  isShownCommentDialog: false,
  currentCommentValue: {},
  previousChangeTypeList: [],
  progress: 0,
  globalTagListItems: {},
  hashTagPopUpId: '',
  caretPosition: 0,
  internalCaretPosition: 0,
  nodeString: '',
  sharetoclient: false,
  workflowdetailFilter: [],
  selectedFilterType: null,
  workflowItemForCalendar: [],
  requiredDeleteTaskIds: [],
  notificationSettingRules: [],
  documentsNotifications: {},
  clickedItem: {},
  updateWorkflowPosition: false,
  workflowItemsChanges: false,
  items: [],
  selectedTaskForMailSent: {},
  filteredTask: false,
  filteredTaskList: []
}
const regexForHashTag = /(#\w+|#([\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]|[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f\u3131-\uD79D])+)/gmi

const updateModuleId = (copyItem, taskIndex) => {
  let newTask = {}
  if (taskIndex !== undefined) {
    newTask = { ...copyItem.children[taskIndex] }
  } else {
    newTask = JSON.parse(JSON.stringify(copyItem))
  }
  //Update keys
  newTask.id = uuidv4()
  newTask.completed_by = ""
  newTask.event_id = ""
  newTask.isCompleted = false
  newTask.skipDate = ""
  newTask.skipReason = ""
  newTask.skip_by = ""
  newTask.status = ""
  for (const childrenData of (newTask?.children || [])) {
    childrenData.id = uuidv4()
    newTask.completed_by = ""
    newTask.event_id = ""
    newTask.isCompleted = false
    newTask.skipDate = ""
    newTask.skipReason = ""
    newTask.skip_by = ""
    newTask.status = ""
  }
  return newTask
}

const removeTagItems = (textValue, caretPosition) => {
  if (textValue.charAt(caretPosition - 1) === "#") {
    const stringArray = textValue.split('')
    stringArray.splice(caretPosition - 1, 1)
    const removeText = stringArray.join('')
    return [removeText, 1]
  } else {
    const beforeCaretString = textValue.slice(0, caretPosition)
    const lastIndexOfHashTag = beforeCaretString.lastIndexOf("#")
    const removeText = textValue.slice(0, lastIndexOfHashTag) + textValue.slice(caretPosition)
    return [removeText, caretPosition - lastIndexOfHashTag]
  }
}

// Helper to clear comments from item and its children
const clearComments = (item) => ({
  ...item,
  comments: [],
  comment_status: [],
  children: item.children?.map(child => ({
    ...child,
    comments: [],
    comment_status: []
  })) || []
})
const workflowEditorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INITIAL_WORKFLOW_ITEM":
      return {
        ...state,
        workflowItems: action.payload
      }
    case "WORKFLOW_TEMPLATE_SELECT":

      return {
        ...state,
        workflowItems: action.payload
      }
    case "FILTERDATA_BY_BINDTEMPLATE":

      return {
        ...state,
        workflowItems: action.payload
      }
    case 'INITIAL_SET_TAG_LIST':
      return {
        ...state,
        globalTagListItems: action.payload
      }
    case "ADD_WORKFLOW_ITEM":
      const globalTagListItemsTemp = { ...state.globalTagListItems }
      const getNodeIdList = GetIdOfNodeFromObject(action.payload)
      for (let i = 0; i < getNodeIdList.length; i++) {
        globalTagListItemsTemp[getNodeIdList[i]] = []
      }
      return {
        ...state,
        workflowItems: [...state.workflowItems, action.payload],
        workflowdetailFilter: [...state.workflowdetailFilter, action.payload],
        globalTagListItems: globalTagListItemsTemp
      }
    case "UPDATE_WORKFLOW_ITEM":
      //Set task text 
      const workDataTemp = [...state.workflowItems]
      const globalTagListItemsTTT = { ...state.globalTagListItems }
      const caretPos = action.payload.caretPosition
      const newTag = []
      let hashTagPopUpIdTemp = state.hashTagPopUpId
      const test = action.payload.evt.currentTarget.innerText.replace(regexForHashTag, function (match) {
        if (match) {
          const result = `<b>${match}</b>`
          return result
        }
      })
      // manage the tag list record
      const found = action.payload.evt.currentTarget.innerText.match(regexForHashTag)
      if (found) {
        for (let i = 0; i < found.length; i++) {
          const tags = found[i]
          newTag.push(tags)
        }
      }
      const internalCaretPositionTT = action.payload.caretPosition + (7 * newTag.length)
      const normalString = action.payload.evt.currentTarget.innerText
      if (normalString.charAt(caretPos - 1) === "#" && !(normalString.charAt(caretPos) === '' || normalString.charAt(caretPos) === ' ')) {
        hashTagPopUpIdTemp = ""
      }
      globalTagListItemsTTT[action.payload.currentLineId] = newTag
      const currentIndex = GetIndexValueFromWorkflowData(workDataTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndex?.hasOwnProperty("moduleIndex") && currentIndex?.hasOwnProperty('taskIndex') && (currentIndex.taskIndex && currentIndex.moduleIndex) !== undefined) {
        // workDataTemp[currentIndex.moduleIndex].children[currentIndex.taskIndex].text = test
        workDataTemp[currentIndex.moduleIndex].children[currentIndex.taskIndex].text = decodeHtmlEntities(test)
      } else if (currentIndex?.hasOwnProperty("moduleIndex")) {
        // workDataTemp[currentIndex.moduleIndex].text = test
        workDataTemp[currentIndex.moduleIndex].text = decodeHtmlEntities(test)
      }

      return {
        ...state,
        workflowItems: workDataTemp,
        globalTagListItems: globalTagListItemsTTT,
        caretPosition: action.payload.caretPosition,
        internalCaretPosition: internalCaretPositionTT,
        hashTagPopUpId: hashTagPopUpIdTemp,
        nodeString: action.payload.evt.currentTarget.innerText
      }
    case "SHOWN_COMMENT_DIALOG":
      return {
        ...state,
        isShownCommentDialog: true,
        currentCommentValue: action.payload
      }
    case "HIDE_COMMENT_DIALOG":
      return {
        ...state,
        isShownCommentDialog: false
      }
    case "TOGGLE_COMMENT_DIALOG":
      return {
        ...state,
        isShownCommentDialog: !state.isShownCommentDialog
      }
    case "ADD_COMMENT":
      //Set comments in workflowItems by currentLineId
      const currentIndexTemp = GetIndexValueFromWorkflowData(workflowData, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTemp?.hasOwnProperty("moduleIndex") && currentIndexTemp?.hasOwnProperty('taskIndex')) {
        if (workflowData[currentIndexTemp.moduleIndex].children[currentIndexTemp.taskIndex].comments[0].text === "") {
          workflowData[currentIndexTemp.moduleIndex].children[currentIndexTemp.taskIndex].comments[0].text = action.payload.commentValue
          workflowData[currentIndexTemp.moduleIndex].children[currentIndexTemp.taskIndex].comments[0].time = new Date()
        } else {
          // workflowData[currentIndexTemp.moduleIndex].children[currentIndexTemp.taskIndex].comments.push({
          //   text: action.payload.commentValue,
          //   commentedBy: 'system',
          //   time: new Date()
          // })
        }
      } else if (currentIndexTemp?.hasOwnProperty("moduleIndex")) {
        if (workflowData[currentIndexTemp.moduleIndex].comments[0].text === "") {
          workflowData[currentIndexTemp.moduleIndex].comments[0].text = action.payload.commentValue
          workflowData[currentIndexTemp.moduleIndex].comments[0].time = new Date()
        } else {
          // workflowData[currentIndexTemp.moduleIndex].comments.push({
          //   text: action.payload.commentValue,
          //   commentedBy: 'system',
          //   time: new Date()
          // })
        }
      }
      return {
        ...state,
        workflowItems: workflowData,
        isShownCommentDialog: false
      }
    case "SHARE_TO_CLIENT":
      const workDataSTC = [...state.workflowItems]
      const workFilterDataSTC = [...state.workflowdetailFilter]
      if (action.filter === null) {
        workDataSTC.map(i => {
          const childrenArr = i.children.filter(j => j.id === action.payload.currentLineId)
          if (i.id === action.payload.currentLineId) {
            i.sharetoclient = !i.sharetoclient
          } else if (childrenArr.length > 0) {
            childrenArr[0].sharetoclient = !childrenArr[0].sharetoclient
          }
          return i
        })
      } else {
        workFilterDataSTC.map(i => {
          const childrenArr = i.children.filter(j => j.id === action.payload.currentLineId)
          if (i.id === action.payload.currentLineId) {
            i.sharetoclient = !i.sharetoclient
          } else if (childrenArr.length > 0) {
            childrenArr[0].sharetoclient = !childrenArr[0].sharetoclient
          }
          return i
        })
      }
      return {
        ...state,
        workflowItems: action.filter === null ? workDataSTC : workFilterDataSTC
      }
    case "ADD_MODULE_OR_TASK":
      //Add new task in workflowItems with extension
      const workDataT = [...state.workflowItems]
      const globalTagListItemsT = { ...state.globalTagListItems }
      const currentIndexObj = GetIndexValueFromWorkflowData(workDataT, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      const taskObj = TaskData()
      taskObj["created_by"] = getUserData().username
      globalTagListItemsT[taskObj.id] = []

      //Added extension to sub child task of parent task.
      //When child task was added into parent task.
      const parentItem = workDataT[currentIndexObj?.moduleIndex]
      taskObj["extension"] = !isEmpty(parentItem?.extension) ? { ...parentItem.extension } : {}

      workDataT[currentIndexObj.moduleIndex].children.splice(currentIndexObj.taskIndex + 1, 0, taskObj)

      return {
        ...state,
        workflowItems: workDataT,
        globalTagListItems: globalTagListItemsT
      }
    case "WORKFLOW_FILTER":
      return {
        ...state,
        workflowdetailFilter: action.payload
      }
    case "INITIAL_WORKFLOW":
      return {
        ...state,
        initialWorkflow: JSON.parse(JSON.stringify([...action.payload]))
      }
    case "WORKFLOW_FILTER_TYPE":
      return {
        ...state,
        selectedFilterType: action.payload
      }
    case 'DELETE_MODULE_OR_TASK':
      //Delete task from workflowItems by currentLIneId and delete from infinite scroll items
      const workDataTT = [...state.workflowItems]
      let previousChangeTypeListT = [...state.previousChangeTypeList]
      const globalTagListItemsTT = { ...state.globalTagListItems }
      const currentIndexT = GetIndexValueFromWorkflowData(workDataTT, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexT?.hasOwnProperty("moduleIndex") && currentIndexT?.hasOwnProperty('taskIndex')) {
        const index = previousChangeTypeListT.indexOf(action.payload.currentLineId)
        if (index > -1) {
          previousChangeTypeListT.splice(index, 1)
        }
        // delete tag from global list
        delete globalTagListItemsTT[action.payload.currentLineId]
        if (workDataTT[currentIndexT.moduleIndex].children?.length > 0) {
          workDataTT[currentIndexT.moduleIndex].children.splice(currentIndexT.taskIndex, 1)
        }
      } else if (currentIndexT?.hasOwnProperty("moduleIndex")) {
        let childIdList = []
        childIdList = workDataTT[currentIndexT.moduleIndex].children.filter((x) => x.id && x.isCompleted && x.type === "PARAGRAPH").map((y) => y.id)
        if (workDataTT[currentIndexT.moduleIndex].type === "PARAGRAPH" && workDataTT[currentIndexT.moduleIndex].isCompleted) {
          childIdList.push(workDataTT[currentIndexT.moduleIndex].id)
        }
        previousChangeTypeListT = previousChangeTypeListT.filter((item) => { return childIdList.indexOf(item) === -1 })

        // delete tag from global lists
        delete globalTagListItemsTT[action.payload.currentLineId]
        if (workDataTT[currentIndexT.moduleIndex].children.length > 0) {
          for (let i = 0; i < workDataTT[currentIndexT.moduleIndex].children.length; i++) {
            delete globalTagListItemsTT[workDataTT[currentIndexT.moduleIndex].children[i].id]
          }
        }
        workDataTT.splice(currentIndexT.moduleIndex, 1)
      }
      return {
        ...state,
        workflowItems: workDataTT,
        previousChangeTypeList: previousChangeTypeListT,
        globalTagListItems: globalTagListItemsTT,
        items: state?.items?.filter(d => d.id !== action.payload.currentLineId)
      }
    case "REQUIRED_DELETE_TASK_LIST_ID":
      //Set deleted task ids
      const deleteIds = action.payload
      if (Array.isArray(deleteIds)) {
        return {
          ...state,
          requiredDeleteTaskIds: [...state.requiredDeleteTaskIds, ...action.payload]
        }
      }
      return {
        ...state,
        requiredDeleteTaskIds: [...state.requiredDeleteTaskIds, action.payload]
      }
    case 'UPDATE_MODULE_OR_TASK_PROGRESS':
      const workDataTTT = [...state.workflowItems]
      const currentIndexTT = GetIndexValueFromWorkflowData(workDataTTT, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTT?.hasOwnProperty("moduleIndex") && currentIndexTT?.hasOwnProperty('taskIndex')) {
        workDataTTT[currentIndexTT.moduleIndex].children[currentIndexTT.taskIndex].isCompleted = action.payload.value
        workDataTTT[currentIndexTT.moduleIndex].children[currentIndexTT.taskIndex].status = action?.payload?.value ? "completed" : ""
        workDataTTT[currentIndexTT.moduleIndex].children[currentIndexTT.taskIndex].completed_by = getUserData().username
      } else if (currentIndexTT?.hasOwnProperty("moduleIndex")) {
        workDataTTT[currentIndexTT.moduleIndex].isCompleted = action.payload.value
        workDataTTT[currentIndexTT.moduleIndex].status = action?.payload?.value ? "completed" : ""
        workDataTTT[currentIndexTT.moduleIndex].completed_by = getUserData().username
      }

      return {
        ...state,
        workflowItems: workDataTTT
      }
    case 'TASK_COMPLETED_DATE':
      const workDataTaskCompleted = [...state.workflowItems]
      const currentIndexTaskCompleted = GetIndexValueFromWorkflowData(workDataTaskCompleted, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTaskCompleted?.hasOwnProperty("moduleIndex") && currentIndexTaskCompleted?.hasOwnProperty('taskIndex')) {
        workDataTaskCompleted[currentIndexTaskCompleted.moduleIndex].children[currentIndexTaskCompleted.taskIndex].completedDate = action.payload.task_completed
        workDataTaskCompleted[currentIndexTaskCompleted.moduleIndex].children[currentIndexTaskCompleted.taskIndex].notificationActions = updateNotificationRuleActions((workDataTaskCompleted[currentIndexTaskCompleted.moduleIndex].children[currentIndexTaskCompleted.taskIndex]?.notificationActions || []), "taskcomplete")
      } else if (currentIndexTaskCompleted?.hasOwnProperty("moduleIndex")) {
        workDataTaskCompleted[currentIndexTaskCompleted.moduleIndex].completedDate = action.payload.task_completed
        workDataTaskCompleted[currentIndexTaskCompleted.moduleIndex].notificationActions = updateNotificationRuleActions((workDataTaskCompleted[currentIndexTaskCompleted.moduleIndex]?.notificationActions || []), "taskcomplete")
      }

      return {
        ...state,
        workflowItems: workDataTaskCompleted
      }
    case 'SET_AUTO_COMPLETE_TASK':
      //Set autoComplete task in workflowItems by currentLineId
      //AutoComplete task is complete automatically every 4 hour.
      const workDataAutoCompleted = [...state.workflowItems]
      const currentIndexAutoCompleted = GetIndexValueFromWorkflowData(workDataAutoCompleted, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAutoCompleted?.hasOwnProperty("moduleIndex") && currentIndexAutoCompleted?.hasOwnProperty('taskIndex')) {
        workDataAutoCompleted[currentIndexAutoCompleted.moduleIndex].children[currentIndexAutoCompleted.taskIndex].isAutoCompleted = action?.payload?.isAutoCompleted || false
      } else if (currentIndexAutoCompleted?.hasOwnProperty("moduleIndex")) {
        workDataAutoCompleted[currentIndexAutoCompleted.moduleIndex].isAutoCompleted = action?.payload?.isAutoCompleted || false
      }


      return {
        ...state,
        workflowItems: workDataAutoCompleted
      }
    case 'UPDATE_WORKFLOW_ITEM_DETAILS':
      const workDataTaskDetails = [...state.workflowItems]
      const currentIndexTaskDetails = GetIndexValueFromWorkflowData(workDataTaskDetails, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTaskDetails?.hasOwnProperty("moduleIndex") && currentIndexTaskDetails?.hasOwnProperty('taskIndex')) {
        workDataTaskDetails[currentIndexTaskDetails.moduleIndex].children[currentIndexTaskDetails.taskIndex].detail = action.payload.value
      } else if (currentIndexTaskDetails?.hasOwnProperty("moduleIndex")) {
        workDataTaskDetails[currentIndexTaskDetails.moduleIndex].detail = action.payload.value
      }

      return {
        ...state,
        workflowItems: workDataTaskDetails
      }
    case 'UPDATE_WORKFLOW_ITEM_EVENT_ID':
      const workDataTaskEvent = [...state.workflowItems]
      const currentIndexTaskEvent = GetIndexValueFromWorkflowData(workDataTaskEvent, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTaskEvent?.hasOwnProperty("moduleIndex") && currentIndexTaskEvent?.hasOwnProperty('taskIndex')) {
        workDataTaskEvent[currentIndexTaskEvent.moduleIndex].children[currentIndexTaskEvent.taskIndex].event_id = action.payload.event_id
      } else if (currentIndexTaskEvent?.hasOwnProperty("moduleIndex")) {
        workDataTaskEvent[currentIndexTaskEvent.moduleIndex].event_id = action.payload.event_id
      }
      return {
        ...state,
        workflowItems: workDataTaskEvent
      }
    case 'UPDATE_WORKFLOW_ITEM_REMARK':
      const workDataTaskRemark = [...state.workflowItems]
      const currentIndexTaskRemark = GetIndexValueFromWorkflowData(workDataTaskRemark, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTaskRemark?.hasOwnProperty("moduleIndex") && currentIndexTaskRemark?.hasOwnProperty('taskIndex')) {
        workDataTaskRemark[currentIndexTaskRemark.moduleIndex].children[currentIndexTaskRemark.taskIndex].remarks = action.payload.value
      } else if (currentIndexTaskRemark?.hasOwnProperty("moduleIndex")) {
        workDataTaskRemark[currentIndexTaskRemark.moduleIndex].remarks = action.payload.value
      }

      return {
        ...state,
        workflowItems: workDataTaskRemark
      }
    case 'COPY_MODULE_OR_TASK':
      const workflowDetail = [...state.workflowItems]
      const previousChangeTypeListTT = [...state.previousChangeTypeList]
      const currentIndexData = GetIndexValueFromWorkflowData(workflowDetail, action.payload.currentLineId, state.selectedFilterType?.value ?? null)

      if (currentIndexData?.hasOwnProperty("moduleIndex") && currentIndexData?.hasOwnProperty('taskIndex')) {
        const updateItemDetail = clearComments(updateModuleId(workflowDetail[currentIndexData.moduleIndex], currentIndexData.taskIndex))
        if (updateItemDetail.type === "PARAGRAPH") {
          previousChangeTypeListTT.push(updateItemDetail.id)
        }
        workflowDetail[currentIndexData.moduleIndex].children.splice(currentIndexData.taskIndex + 1, 0, updateItemDetail)

      } else if (currentIndexData?.hasOwnProperty("moduleIndex")) {
        const moduleDetail = clearComments(updateModuleId(workflowDetail[currentIndexData.moduleIndex]))
        if (moduleDetail.type === "PARAGRAPH") {
          previousChangeTypeListTT.push(moduleDetail.id)
        }
        const childIdList = moduleDetail.children.filter((x) => x.isCompleted && x.type === "PARAGRAPH").map((y) => y.id)
        previousChangeTypeListTT.push(...childIdList)
        workflowDetail.splice(currentIndexData.moduleIndex + 1, 0, moduleDetail)
      }

      return {
        ...state,
        workflowItems: workflowDetail,
        previousChangeTypeList: previousChangeTypeListTT,
        updateWorkflowPosition: true
        }
    case 'CHANGE_TYPE':
      //Set task type this feature is in GIMA Workflow only
      const workflowDetailO = [...state.workflowItems]
      const workflowFilterDetailO = [...state.workflowdetailFilter]
      const previousChangeTypeListTemp = [...state.previousChangeTypeList]
      const currentIndexO = GetIndexValueFromWorkflowData(action.filter === null ? workflowDetailO : workflowFilterDetailO, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexO?.hasOwnProperty("moduleIndex") && currentIndexO?.hasOwnProperty('taskIndex')) {
        if (action.filter === null) {
          for (let j = 0; j < workflowDetailO[currentIndexO.moduleIndex].children.length; j++) {
            workflowDetailO[currentIndexO.moduleIndex].children[j].type = action.payload.name
            if (action.payload.name === "PARAGRAPH" && !previousChangeTypeListTemp.includes(workflowDetailO[currentIndexO.moduleIndex].children[j].id)) {
              workflowDetailO[currentIndexO.moduleIndex].children[j].isCompleted = true
              previousChangeTypeListTemp.push(workflowDetailO[currentIndexO.moduleIndex].children[j].id)
            } else if (action.payload.name !== "PARAGRAPH" && previousChangeTypeListTemp.includes(workflowDetailO[currentIndexO.moduleIndex].children[j].id)) {
              const index = previousChangeTypeListTemp.indexOf(workflowDetailO[currentIndexO.moduleIndex].children[j].id)
              if (index > -1) {
                previousChangeTypeListTemp.splice(index, 1)
              }
              workflowDetailO[currentIndexO.moduleIndex].children[j].isCompleted = false
            }
          }
        } else {
          for (let j = 0; j < workflowFilterDetailO[currentIndexO.moduleIndex].children.length; j++) {
            workflowFilterDetailO[currentIndexO.moduleIndex].children[j].type = action.payload.name
            if (action.payload.name === "PARAGRAPH" && !previousChangeTypeListTemp.includes(workflowFilterDetailO[currentIndexO.moduleIndex].children[j].id)) {
              workflowFilterDetailO[currentIndexO.moduleIndex].children[j].isCompleted = true
              previousChangeTypeListTemp.push(workflowFilterDetailO[currentIndexO.moduleIndex].children[j].id)
            } else if (action.payload.name !== "PARAGRAPH" && previousChangeTypeListTemp.includes(workflowFilterDetailO[currentIndexO.moduleIndex].children[j].id)) {
              const index = previousChangeTypeListTemp.indexOf(workflowFilterDetailO[currentIndexO.moduleIndex].children[j].id)
              if (index > -1) {
                previousChangeTypeListTemp.splice(index, 1)
              }
              workflowFilterDetailO[currentIndexO.moduleIndex].children[j].isCompleted = false
            }
          }
        }
      } else if (currentIndexO?.hasOwnProperty("moduleIndex")) {
        if (action.filter === null) {
          workflowDetailO[currentIndexO.moduleIndex].type = action.payload.name
          if (action.payload.name === "PARAGRAPH" && !previousChangeTypeListTemp.includes(workflowDetailO[currentIndexO.moduleIndex].id)) {
            workflowDetailO[currentIndexO.moduleIndex].isCompleted = true
            previousChangeTypeListTemp.push(workflowDetailO[currentIndexO.moduleIndex].id)
          } else if (action.payload.name !== "PARAGRAPH" && previousChangeTypeListTemp.includes(workflowDetailO[currentIndexO.moduleIndex].id)) {
            const index = previousChangeTypeListTemp.indexOf(workflowDetailO[currentIndexO.moduleIndex].id)
            if (index > -1) {
              previousChangeTypeListTemp.splice(index, 1)
            }
            workflowDetailO[currentIndexO.moduleIndex].isCompleted = false
          }
        } else {
          workflowFilterDetailO[currentIndexO.moduleIndex].type = action.payload.name
          if (action.payload.name === "PARAGRAPH" && !previousChangeTypeListTemp.includes(workflowFilterDetailO[currentIndexO.moduleIndex].id)) {
            workflowFilterDetailO[currentIndexO.moduleIndex].isCompleted = true
            previousChangeTypeListTemp.push(workflowFilterDetailO[currentIndexO.moduleIndex].id)
          } else if (action.payload.name !== "PARAGRAPH" && previousChangeTypeListTemp.includes(workflowFilterDetailO[currentIndexO.moduleIndex].id)) {
            const index = previousChangeTypeListTemp.indexOf(workflowFilterDetailO[currentIndexO.moduleIndex].id)
            if (index > -1) {
              previousChangeTypeListTemp.splice(index, 1)
            }
            workflowFilterDetailO[currentIndexO.moduleIndex].isCompleted = false
          }
        }
      }

      return {
        ...state,
        workflowItems: workflowDetailO,
        previousChangeTypeList: previousChangeTypeListTemp
      }
    case 'CHANGE_COLOR':
      const workflowDetailColor = [...state.workflowItems]
      const workflowFilterDetailColor = [...state.workflowdetailFilter]
      const currentIndexC = GetIndexValueFromWorkflowData(action.filter === null ? workflowDetailColor : workflowFilterDetailColor, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexC?.hasOwnProperty("moduleIndex") && currentIndexC?.hasOwnProperty('taskIndex')) {
        if (action.filter === null) {
          workflowDetailColor[currentIndexC.moduleIndex].children[currentIndexC.taskIndex].fontColor = action.payload.color.hex
        } else {
          workflowFilterDetailColor[currentIndexC.moduleIndex].children[currentIndexC.taskIndex].fontColor = action.payload.color.hex
        }
      } else if (currentIndexC?.hasOwnProperty("moduleIndex")) {
        if (action.filter === null) {
          workflowDetailColor[currentIndexC.moduleIndex].fontColor = action.payload.color.hex
        } else {
          workflowFilterDetailColor[currentIndexC.moduleIndex].fontColor = action.payload.color.hex
        }
      }

      return {
        ...state,
        workflowItems: workflowDetailColor
      }
    case 'CHANGE_HIGHLIGHT_COLOR':
      const workflowDetailHighlighColor = [...state.workflowItems]
      const workflowFilterDetailHighlighColor = [...state.workflowdetailFilter]
      const currentIndexH = GetIndexValueFromWorkflowData(action.filter === null ? workflowDetailHighlighColor : workflowFilterDetailHighlighColor, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexH?.hasOwnProperty("moduleIndex") && currentIndexH?.hasOwnProperty('taskIndex')) {
        if (action.filter === null) {
          workflowDetailHighlighColor[currentIndexH.moduleIndex].children[currentIndexH.taskIndex].highlightColor = action.payload.highlightColor.hex
        } else {
          workflowFilterDetailHighlighColor[currentIndexH.moduleIndex].children[currentIndexH.taskIndex].highlightColor = action.payload.highlightColor.hex
        }
      } else if (currentIndexH?.hasOwnProperty("moduleIndex")) {
        if (action.filter === null) {
          workflowDetailHighlighColor[currentIndexH.moduleIndex].highlightColor = action.payload.highlightColor.hex
        } else {
          workflowFilterDetailHighlighColor[currentIndexH.moduleIndex].highlightColor = action.payload.highlightColor.hex
        }
      }

      return {
        ...state,
        workflowItems: workflowDetailHighlighColor
      }
    case 'UPDATE_WORKFLOW_POSITION':
      const oldItems = state?.items
      let updatedItem = state?.workflowItems.filter(d => !action.payload.map(s => s.id).includes(d.id))
      if (action.payload.length < oldItems.length) {
        const taskNotInOldItems = oldItems.filter(d => !action?.payload?.map(s => s.id).includes(d.id))
        if (!isEmpty(taskNotInOldItems)) {
          updatedItem = state?.workflowItems.filter(c => !taskNotInOldItems.map(d => d.id).includes(c.id)).filter(d => !action.payload.map(s => s.id).includes(d.id))
        }
      }
      updatedItem.unshift(...action.payload)
      return {
        ...state,
        workflowItems: updatedItem
      }
    case "UPDATE_WORKFLOW_POSITION_TASK": {
      return {
        ...state,
        updateWorkflowPosition: action.payload
      }
    }

    case 'SORT_WORKFLOW_POSITION':
      /**
       * Sorts workflow items based on their status and completion state.
       * @returns {Array} Sorted workflow items with completed tasks first, followed by incomplete ones, ordered by their status.
       */
      const workflowItemsSorted = [...state.workflowItems].sort((a, b) => {
        const isFinished = (item) => {
          const isSkip = (item.status === 'skip' || !!item.skipDate)
          return item?.isCompleted || isSkip
        }
        const getGroupPriority = (status) => {
          if (status === 'completed' || status === 'complete' || status === 'skip') {
            return 0
          }
          return 1 // Everything else (pending, etc.)
        }
        const priorityComparison = getGroupPriority(a.status) - getGroupPriority(b.status)
        if (priorityComparison !== 0) return priorityComparison

        // 2. Tertiary Sort: Combined Date (Older at the top)
        const getDateValue = (item) => {
          if (!isFinished(item)) return Infinity
          // This picks the available date regardless of status
          const dateStr = item.completedDate || item.skipDate
          return dateStr ? new Date(dateStr).getTime() : Infinity
        }

        const dateA = getDateValue(a)
        const dateB = getDateValue(b)

        return dateA - dateB
      })
      return {
        ...state,
        workflowItems: workflowItemsSorted,
      }

    /**
       * @method CALCULATE_PROGRESS_OF_MODULE_AND_TASK
       * for gima workflow and eng system calculating progress with all tasks.
       * In business workflow only consider those task which is have milestone.
      */
    case 'CALCULATE_PROGRESS_OF_MODULE_AND_TASK':
      //Calculate progress by corresponding conditions and set in progress strate
      const flow = action.flow
      let workflowDataItems = []
      if (flow === "BUSINESS_WORKFLOW") workflowDataItems = [...state.workflowItems]?.filter(d => JSON.stringify(d.extension) === JSON.stringify(action?.filter))
      else workflowDataItems = [...state.workflowItems]
      const isEsg = Boolean(workflowDataItems[0]?.extension?.action_id)
      if (workflowDataItems && workflowDataItems.length === 0) {
        return { ...state, progress: 0 }
      } else {
        const totalItem = workflowDataItems.map((item) => {
          if (item.children !== undefined) {
            return item.children.length
          } else {
            return 0
          }
        })

        const totalCheckbox = totalItem.reduce((a, b) => a + b, 0)

        let allCompleteTaskCount = 0
        let completedMilestoneTaskCount = 0
        let allMileStoneTaskCount = 0
        const allTaskCount = (workflowDataItems?.length + totalCheckbox)
        for (let i = 0; i < workflowDataItems.length; i++) {
          if (flow === "BUSINESS_WORKFLOW" && !isEsg) {
            if (!isEmpty(workflowDataItems[i]?.tag)) {
              if (workflowDataItems[i]?.tag?.map(d => d[0]).includes("Milestone")) {
                allMileStoneTaskCount += 1
                if (workflowDataItems[i].isCompleted || workflowDataItems[i]?.status === "skip") completedMilestoneTaskCount += 1
              }
            }
            for (let j = 0; j < workflowDataItems[i]?.children?.length; j++) {
              if (!isEmpty(workflowDataItems[i]?.children[j]?.tag)) {
                if (workflowDataItems[i]?.children[j]?.tag?.map(d => d[0]).includes("Milestone")) {
                  allMileStoneTaskCount += 1
                  if (workflowDataItems[i]?.children[j]?.isCompleted || workflowDataItems[i]?.children[j]?.status === "skip") completedMilestoneTaskCount += 1
                }
              }
            }
          } else {
            if (workflowDataItems[i]?.isCompleted || workflowDataItems[i]?.status === "skip") {
              allCompleteTaskCount += 1
            }
            for (let j = 0; j < workflowDataItems[i]?.children.length; j++) {
              if (workflowDataItems[i]?.children[j]?.isCompleted || workflowDataItems[i]?.children[j]?.status === "skip") {
                allCompleteTaskCount += 1
              }
            }
          }
        }
        if (flow === "BUSINESS_WORKFLOW" && !isEsg) {
          let finalCount = 0
          if (completedMilestoneTaskCount === 0 && allMileStoneTaskCount === 0) {
            return { ...state, progress: parseInt(finalCount.toFixed(0)) }
          } else {
            finalCount = (completedMilestoneTaskCount / allMileStoneTaskCount) * 100
            return { ...state, progress: parseInt(finalCount.toFixed(0)) }
          }

        } else {
          let finalCount = 0
          if (allCompleteTaskCount === 0 && allTaskCount === 0) {
            return { ...state, progress: parseInt(finalCount.toFixed(0)) }
          } else {
            finalCount = (allCompleteTaskCount / allTaskCount) * 100
            return { ...state, progress: parseInt(finalCount.toFixed(0)) }
          }
        }
      }
    case 'HANDLE_HASH_POPUP':
      let currentLineIdTemp = action.payload.currentLineId ? action.payload.currentLineId : state.hashTagPopUpId
      const evt = action.payload.eventCode
      // hide the menu list when user pressed the space 
      if (evt.key === ' ') {
        currentLineIdTemp = ''
      }
      // double verify this code
      if (state.hashTagPopUpId && evt.key === 'Backspace' && state.nodeString.charAt(state.caretPosition - 1) === "#") {
        currentLineIdTemp = ''
      }
      return {
        ...state,
        hashTagPopUpId: currentLineIdTemp
      }
    // case 'HANDLE_TAG_CLICK':
    //   const workFlowRecord = [...state.workflowItems]
    //   let internalCaretPositionTemp = state.internalCaretPosition
    //   const caretPositionValue = state.caretPosition
    //   const nodeStringTemp = state.nodeString
    //   const currentIndexWI = GetIndexValueFromWorkflowData(workFlowRecord, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
    //   if (currentIndexWI?.hasOwnProperty("moduleIndex") && currentIndexWI?.hasOwnProperty('taskIndex')) {
    //     const result = removeTagItems(nodeStringTemp, caretPositionValue)
    //     internalCaretPositionTemp = caretPositionValue - result[1]
    //     const newString = [result[0].slice(0, internalCaretPositionTemp), action.payload.tag, result[0].slice(internalCaretPositionTemp)].join('')
    //     const finalString = newString.replace(regexForHashTag, function (match) {
    //       if (match) {
    //         const result = `<b>${match}</b>`
    //         return result
    //       }
    //     })
    //     workFlowRecord[currentIndexWI.moduleIndex].children[currentIndexWI.taskIndex].text = finalString
    //   } else if (currentIndexWI?.hasOwnProperty("moduleIndex")) {
    //     const result = removeTagItems(nodeStringTemp, caretPositionValue)
    //     internalCaretPositionTemp = caretPositionValue - result[1]
    //     const newString = [result[0].slice(0, internalCaretPositionTemp), action.payload.tag, result[0].slice(internalCaretPositionTemp)].join('')
    //     const finalString = newString.replace(regexForHashTag, function (match) {
    //       if (match) {
    //         const result = `<b>${match}</b>`
    //         return result
    //       }
    //     })
    //     workFlowRecord[currentIndexWI.moduleIndex].text = finalString
    //   }
    //   return {
    //     ...state,
    //     workflowItems: workFlowRecord,
    //     hashTagPopUpId: '',
    //   }
    case 'DUE_DATE':
      //Set due date and notificationAction for workflowItems
      const workflowDataDueDateTemp = [...state.workflowItems]
      const workflowItemsDataDueDateTemp = [...state.items]

      const currentIndexATDueDate = GetIndexValueFromWorkflowData(workflowDataDueDateTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      const currentIndexATDueDateFromItems = GetIndexValueFromWorkflowData(workflowItemsDataDueDateTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)

      const dueDate = Array.isArray(action.payload?.due_date) ? action.payload?.due_date[0] : action.payload?.due_date
      if (currentIndexATDueDate?.hasOwnProperty("moduleIndex") && currentIndexATDueDate?.hasOwnProperty('taskIndex')) {
        if (!isEmpty(action.payload?.due_date)) {
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].children[currentIndexATDueDate.taskIndex].dueDate = moment(dueDate).toISOString()
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].children[currentIndexATDueDate.taskIndex].notificationActions = updateNotificationRuleActions(workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].children[currentIndexATDueDate.taskIndex]?.notificationActions || [], "updateduedate")
          workflowItemsDataDueDateTemp[currentIndexATDueDateFromItems.moduleIndex].children[currentIndexATDueDateFromItems.taskIndex].dueDate = moment(dueDate).toISOString()
        } else {
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].children[currentIndexATDueDate.taskIndex].dueDate = null
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].children[currentIndexATDueDate.taskIndex].notificationActions = updateNotificationRuleActions(workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].children[currentIndexATDueDate.taskIndex]?.notificationActions || [], "updateduedate")
          workflowItemsDataDueDateTemp[currentIndexATDueDateFromItems.moduleIndex].children[currentIndexATDueDateFromItems.taskIndex].dueDate = null
        }
      } else if (currentIndexATDueDate?.hasOwnProperty("moduleIndex")) {
        if (!isEmpty(action.payload?.due_date)) {
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].dueDate = moment(dueDate).toISOString()
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].notificationActions = updateNotificationRuleActions(workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex]?.notificationActions || [], "updateduedate")
          workflowItemsDataDueDateTemp[currentIndexATDueDateFromItems.moduleIndex].dueDate = moment(dueDate).toISOString()
        } else {
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].dueDate = null
          workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex].notificationActions = updateNotificationRuleActions(workflowDataDueDateTemp[currentIndexATDueDate.moduleIndex]?.notificationActions || [], "updateduedate")
          workflowItemsDataDueDateTemp[currentIndexATDueDateFromItems.moduleIndex].dueDate = null
        }
      }
      return {
        ...state,
        workflowItems: workflowDataDueDateTemp,
        items: workflowItemsDataDueDateTemp // When due date change items not updated, so set here items update
      }
    case 'TAG_TASK':
      //Set tag in workflowItems by currentLineId
      const workflowDataTagTemp = [...state.workflowItems]
      const currentIndexAtTag = GetIndexValueFromWorkflowData(workflowDataTagTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAtTag?.hasOwnProperty("moduleIndex") && currentIndexAtTag?.hasOwnProperty('taskIndex')) {
        workflowDataTagTemp[currentIndexAtTag.moduleIndex].children[currentIndexAtTag.taskIndex].tag = action.payload.tag
        workflowDataTagTemp[currentIndexAtTag.moduleIndex].children[currentIndexAtTag.taskIndex].report_tag = action.payload.report_tag
      } else if (currentIndexAtTag?.hasOwnProperty("moduleIndex")) {
        workflowDataTagTemp[currentIndexAtTag.moduleIndex].tag = action.payload.tag
        workflowDataTagTemp[currentIndexAtTag.moduleIndex].report_tag = action.payload.report_tag
      }
      return {
        ...state,
        workflowItems: workflowDataTagTemp
      }
    case 'MAIL_LOG_TASK':
      //Set mail log when sent mail in workflowItems that is store mail sent history
      const workflowDataMailLogTemp = [...state.workflowItems]
      const currentIndexAtMailLog = GetIndexValueFromWorkflowData(workflowDataMailLogTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAtMailLog?.hasOwnProperty("moduleIndex") && currentIndexAtMailLog?.hasOwnProperty('taskIndex')) {
        workflowDataMailLogTemp[currentIndexAtMailLog.moduleIndex].children[currentIndexAtMailLog.taskIndex].sentMails = action.payload.mails
      } else if (currentIndexAtMailLog?.hasOwnProperty("moduleIndex")) {
        workflowDataMailLogTemp[currentIndexAtMailLog.moduleIndex].sentMails = action.payload.mails
      }
      return {
        ...state,
        workflowItems: workflowDataMailLogTemp
      }
    case 'DOC_LOG_TASK':
      //Set document upload and required notification action in workflowItems.
      const workflowDataDocLogTemp = [...state.workflowItems]
      const currentIndexAtDocLog = GetIndexValueFromWorkflowData(workflowDataDocLogTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAtDocLog?.hasOwnProperty("moduleIndex") && currentIndexAtDocLog?.hasOwnProperty('taskIndex')) {
        const existingActions = workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex]?.notificationActions || []
        const existingTaskDocs = workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex]?.uploadedDocs || []
        if (!workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].hasOwnProperty("uploadedDocs_payload")) {
          workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].uploadedDocs_payload = existingTaskDocs
        }
        if (action?.action === "deleteDoc") {
          const taskDocs = [...action.payload.docs]
          const payloadDocs = workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].uploadedDocs_payload
          payloadDocs.forEach(d => {
            const doc = taskDocs.find(s => s.id === d.id)
            if (isEmpty(doc)) {
              workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].notificationActions =
                updateNotificationRuleActions(existingActions, "deletdocuments")
            }
          })
          if (action.payload.docs.length === 0) {
            workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].notificationActions =
              workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].notificationActions.filter(d => d !== "uploaddocument")
          } else {
            if (taskDocs.length === payloadDocs.length) {
              const allPayloadIds = payloadDocs.map(d => d.id)
              const allTaskDocsIds = taskDocs.map(d => d.id)
              const isSame = allTaskDocsIds.filter(d => allPayloadIds.includes(d))
              if (allPayloadIds.length === isSame.length) {
                workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].notificationActions =
                  workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].notificationActions.filter(d => d !== "uploaddocument")
              }
            }
          }
        } else {
          workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].notificationActions =
            updateNotificationRuleActions(existingActions, "uploaddocument")
        }
        workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].children[currentIndexAtDocLog.taskIndex].uploadedDocs = action.payload.docs
      } else if (currentIndexAtDocLog?.hasOwnProperty("moduleIndex")) {
        const existingActions = workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex]?.notificationActions || []
        const existingTaskDocs = workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex]?.uploadedDocs || []
        if (!workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].hasOwnProperty("uploadedDocs_payload")) {
          workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].uploadedDocs_payload = existingTaskDocs
        }
        if (action?.action === "deleteDoc") {
          const taskDocs = [...action.payload.docs]
          const payloadDocs = workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].uploadedDocs_payload
          payloadDocs.forEach(d => {
            const doc = taskDocs.find(s => s.id === d.id)
            if (isEmpty(doc)) {
              workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].notificationActions =
                updateNotificationRuleActions(existingActions, "deletdocuments")
            }
          })
          if (action.payload.docs.length === 0) {
            workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].notificationActions =
              workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].notificationActions.filter(d => d !== "uploaddocument")
          } else {
            if (taskDocs.length === payloadDocs.length) {
              const allPayloadIds = payloadDocs.map(d => d.id)
              const allTaskDocsIds = taskDocs.map(d => d.id)
              const isSame = allTaskDocsIds.filter(d => allPayloadIds.includes(d))
              if (allPayloadIds.length === isSame.length) {
                workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].notificationActions =
                  workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].notificationActions.filter(d => d !== "uploaddocument")
              }
            }
          }
        } else {
          workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].notificationActions =
            updateNotificationRuleActions(existingActions, "uploaddocument")
        }
        workflowDataDocLogTemp[currentIndexAtDocLog.moduleIndex].uploadedDocs = action.payload.docs
      }
      return {
        ...state,
        workflowItems: workflowDataDocLogTemp,
      }

    case "CLEAR_NOTIFICATION_ACTIONS":
      //Clear notification actions in workflowItems
      let workflowNotificationActionTask = [...state.workflowItems]
      workflowNotificationActionTask = workflowNotificationActionTask.map((i) => {
        if (!isEmpty(i.notificationActions)) {
          i.notificationActions = []
        }
        if (i.hasOwnProperty("uploadedDocs_payload")) {
          delete i.uploadedDocs_payload
        }
        if (!isEmpty(i.children)) {
          i.children = i.children.map((d) => {
            if (!isEmpty(d.notificationActions)) {
              d.notificationActions = []
            }
            if (d.hasOwnProperty("uploadedDocs_payload")) {
              delete d.uploadedDocs_payload
            }
            return d
          })
        }
        return i
      })
      return {
        ...state,
        workflowItems: workflowNotificationActionTask
      }

    case 'ASSIGN_TASK':
      // Set assignee in workflowItems by currentLineId
      //Set notification actions in workflowItems for send notification from backend
      const workflowDataTaskTemp = [...state.workflowItems]
      const currentIndexAT = GetIndexValueFromWorkflowData(workflowDataTaskTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAT?.hasOwnProperty("moduleIndex") && currentIndexAT?.hasOwnProperty('taskIndex')) {
        workflowDataTaskTemp[currentIndexAT.moduleIndex].children[currentIndexAT.taskIndex].assignedTo = action.payload.assigned
        workflowDataTaskTemp[currentIndexAT.moduleIndex].children[currentIndexAT.taskIndex].notificationActions = updateNotificationRuleActions(workflowDataTaskTemp[currentIndexAT.moduleIndex].children[currentIndexAT.taskIndex]?.notificationActions || [], "updateassignto")
      } else if (currentIndexAT?.hasOwnProperty("moduleIndex")) {
        workflowDataTaskTemp[currentIndexAT.moduleIndex].assignedTo = action.payload.assigned
        workflowDataTaskTemp[currentIndexAT.moduleIndex].notificationActions = updateNotificationRuleActions(workflowDataTaskTemp[currentIndexAT.moduleIndex]?.notificationActions || [], "updateassignto")
      }
      return {
        ...state,
        workflowItems: workflowDataTaskTemp
      }
    case 'ASSIGN_TEMPLATE':
      // Set mail template in workflowItems by currentLineId
      const workflowDataTemplateTemp = [...state.workflowItems]
      const currentIndexTemplateAT = GetIndexValueFromWorkflowData(workflowDataTemplateTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTemplateAT?.hasOwnProperty("moduleIndex") && currentIndexTemplateAT?.hasOwnProperty('taskIndex')) {
        workflowDataTemplateTemp[currentIndexTemplateAT.moduleIndex].children[currentIndexTemplateAT.taskIndex].mailTemplateId = action.payload.template_ids
      } else if (currentIndexTemplateAT?.hasOwnProperty("moduleIndex")) {
        workflowDataTemplateTemp[currentIndexTemplateAT.moduleIndex].mailTemplateId = action.payload.template_ids
      }

      return {
        ...state,
        workflowItems: workflowDataTemplateTemp
      }
    case 'ASSIGN_REPORT_TYPE':
      //Set report tag in workflowItems by currentLineId
      const TemplateReportTypeData = [...state.workflowItems]
      const currentIndexReportTypeAT = GetIndexValueFromWorkflowData(TemplateReportTypeData, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexReportTypeAT?.hasOwnProperty("moduleIndex") && currentIndexReportTypeAT?.hasOwnProperty('taskIndex')) {
        TemplateReportTypeData[currentIndexReportTypeAT.moduleIndex].children[currentIndexReportTypeAT.taskIndex].report_tag = action?.payload?.reportTag || null
      } else if (currentIndexReportTypeAT?.hasOwnProperty("moduleIndex")) {
        TemplateReportTypeData[currentIndexReportTypeAT.moduleIndex].report_tag = action?.payload?.reportTag || null
      }
      return {
        ...state,
        workflowItems: TemplateReportTypeData
      }
    case 'ASSIGN_AUTO_SET_TEMPLATE':
      //Set autoSetMailTemplateId in workflowItems by currentLineId
      const workflowDataAutoSetTemplate = [...state.workflowItems]
      const currentIndexAutoSetTemplateAT = GetIndexValueFromWorkflowData(workflowDataAutoSetTemplate, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAutoSetTemplateAT?.hasOwnProperty("moduleIndex") && currentIndexAutoSetTemplateAT?.hasOwnProperty('taskIndex')) {
        workflowDataAutoSetTemplate[currentIndexAutoSetTemplateAT.moduleIndex].children[currentIndexAutoSetTemplateAT.taskIndex].autoSetMailTemplateId = action.payload.template_ids
      } else if (currentIndexAutoSetTemplateAT?.hasOwnProperty("moduleIndex")) {
        workflowDataAutoSetTemplate[currentIndexAutoSetTemplateAT.moduleIndex].autoSetMailTemplateId = action.payload.template_ids
      }

      return {
        ...state,
        workflowItems: workflowDataAutoSetTemplate
      }

    case 'REMOVE_TEMPLATE':
      //Remove mail template in workflowItems by currentLineId
      const workflowRemoveItems = [...state.workflowItems]
      const currentIndexRemoveTemplateAT = GetIndexValueFromWorkflowData(workflowRemoveItems, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexRemoveTemplateAT?.hasOwnProperty("moduleIndex") && currentIndexRemoveTemplateAT?.hasOwnProperty('taskIndex')) {
        if (!isEmpty(workflowRemoveItems[currentIndexRemoveTemplateAT.moduleIndex].children[currentIndexRemoveTemplateAT.taskIndex].mailTemplateId)) {
          const oldRecord = workflowRemoveItems[currentIndexRemoveTemplateAT.moduleIndex].children[currentIndexRemoveTemplateAT.taskIndex].mailTemplateId
          const emails = oldRecord.filter(item => item !== action.payload.template_id)
          workflowRemoveItems[currentIndexRemoveTemplateAT.moduleIndex].children[currentIndexRemoveTemplateAT.taskIndex].mailTemplateId = emails
        }
      } else if (currentIndexRemoveTemplateAT?.hasOwnProperty("moduleIndex")) {
        if (!isEmpty(workflowRemoveItems[currentIndexRemoveTemplateAT.moduleIndex].mailTemplateId)) {
          const oldRecord = workflowRemoveItems[currentIndexRemoveTemplateAT.moduleIndex].mailTemplateId
          const emails = oldRecord.filter(item => item !== action.payload.template_id)
          workflowRemoveItems[currentIndexRemoveTemplateAT.moduleIndex].mailTemplateId = emails
        }
      }
      return { ...state, workflowItems: workflowRemoveItems }

    // case 'TASK_COMPLETED':
    //   const workflowDataTaskCompletedTemp = [...state.workflowItems]
    //   const workflowFilterDataTaskCompletedTemp = [...state.workflowdetailFilter]
    //   const currentIndexATTaskCompleted = GetIndexValueFromWorkflowData(action.filter === null ? workflowDataTaskCompletedTemp : workflowFilterDataTaskCompletedTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
    //   if (currentIndexATTaskCompleted?.hasOwnProperty("moduleIndex") && currentIndexATTaskCompleted?.hasOwnProperty('taskIndex')) {
    //     if (action.filter === null) {
    //       workflowDataTaskCompletedTemp[currentIndexATTaskCompleted.moduleIndex].children[currentIndexATTaskCompleted.taskIndex].completed = action.payload.completed_task
    //     } else {
    //       workflowFilterDataTaskCompletedTemp[currentIndexATTaskCompleted.moduleIndex].children[currentIndexATTaskCompleted.taskIndex].completed = action.payload.completed_task
    //     }
    //   } else if (currentIndexATTaskCompleted?.hasOwnProperty("moduleIndex")) {
    //     if (action.filter === null) {
    //       workflowDataTaskCompletedTemp[currentIndexATTaskCompleted.moduleIndex].completed = action.payload.completed_task
    //     } else {
    //       workflowFilterDataTaskCompletedTemp[currentIndexATTaskCompleted.moduleIndex].completed = action.payload.completed_task
    //     }
    //   }
    // return {
    //   ...state,
    //   workflowItems: action.filter === null ? workflowDataTaskCompletedTemp : workflowFilterDataTaskCompletedTemp,
    // }
    case "ADD_FILE":
      //Set uploadfile in workflowItems by currentLineId
      const workflowDataTaskFileTemp = [...state.workflowItems]
      const currentIndexAF = GetIndexValueFromWorkflowData(workflowDataTaskFileTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAF?.hasOwnProperty("moduleIndex") && currentIndexAF?.hasOwnProperty('taskIndex')) {
        workflowDataTaskFileTemp[currentIndexAF.moduleIndex].children[currentIndexAF.taskIndex].uploadedFiles = action.payload.file
        workflowDataTaskFileTemp[currentIndexAF.moduleIndex].children[currentIndexAF.taskIndex].notificationActions = updateNotificationRuleActions(workflowDataTaskFileTemp[currentIndexAF.moduleIndex].children[currentIndexAF.taskIndex]?.notificationActions || [], "uploaddocument")
      } else if (currentIndexAF?.hasOwnProperty("moduleIndex")) {
        workflowDataTaskFileTemp[currentIndexAF.moduleIndex].uploadedFiles = action.payload.file
        workflowDataTaskFileTemp[currentIndexAF.moduleIndex].notificationActions = updateNotificationRuleActions(workflowDataTaskFileTemp[currentIndexAF.moduleIndex]?.notificationActions || [], "uploaddocument")
      }

      return {
        ...state,
        workflowItems: workflowDataTaskFileTemp
      }
    case "RESET_WORKFLOW":
      return {
        ...state,
        workflowItems: [],
        workflowDetail: []
      }
    case "RESET_WORKFLOW_ITEMS":
      return {
        ...state,
        workflowItems: [],
        workflowdetailFilter: []
      }
    case UPDATE_TEMPLATE_BRANCH_AND_COMPANY:
      const workflowTempForUpdateInternalTags = [...state.workflowItems]
      const currentIndexInternalTagAT = GetIndexValueFromWorkflowData(workflowTempForUpdateInternalTags, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      const { isCompanyOrBranch, internalTags, isOppositeData, templateBranchAndCompanyItems } = action.payload
      const oppositeTagItem = templateBranchAndCompanyItems.find(d => d?.tagType !== isCompanyOrBranch)

      const applyInternalTags = (item) => {
        const allInternalTag = { ...(item.internal_tag || {}) }
        if (!isEmpty(internalTags)) {
          allInternalTag[isCompanyOrBranch] = internalTags
        } else {
          delete allInternalTag[isCompanyOrBranch]
        }
        if (oppositeTagItem) {
          if (!isEmpty(isOppositeData)) {
            allInternalTag[oppositeTagItem.tagType] = isOppositeData
          } else {
            delete allInternalTag[oppositeTagItem.tagType]
          }
        }
        item.internal_tag = allInternalTag
      }

      if (currentIndexInternalTagAT?.hasOwnProperty("moduleIndex") && currentIndexInternalTagAT?.hasOwnProperty('taskIndex')) {
        applyInternalTags(workflowTempForUpdateInternalTags[currentIndexInternalTagAT.moduleIndex].children[currentIndexInternalTagAT.taskIndex])
      } else if (currentIndexInternalTagAT?.hasOwnProperty("moduleIndex")) {
        applyInternalTags(workflowTempForUpdateInternalTags[currentIndexInternalTagAT.moduleIndex])
      }
      return { ...state, workflowItems: workflowTempForUpdateInternalTags }
    case RESET_TEMPLATE_BRANCH_AND_COMPANY:
      let workflowTempForResetInternalTags = [...state.workflowItems]
      workflowTempForResetInternalTags = workflowTempForResetInternalTags.map(item => {
        if (!isEmpty(item?.internal_tag)) {
          item.backup_internal_tag = { ...item?.internal_tag }
          item.internal_tag = {}
        }
        if (!isEmpty(item?.children)) {
          item.children = item.children.map(child => {
            if (!isEmpty(child?.internal_tag)) {
              child.backup_internal_tag = { ...child?.internal_tag }
              child.internal_tag = {}
            }
            return child
          })
        }
        return item
      })
      return { ...state, workflowItems: workflowTempForResetInternalTags }
    case RESTORE_TEMPLATE_BRANCH_AND_COMPANY:
      let workflowTempForRestoreInternalTags = [...state.workflowItems]
      workflowTempForRestoreInternalTags = workflowTempForRestoreInternalTags.map(item => {
        if (!isEmpty(item?.backup_internal_tag)) {
          item.internal_tag = { ...item?.backup_internal_tag }
          delete item.backup_internal_tag
        }
        if (!isEmpty(item?.children)) {
          item.children = item.children.map(child => {
            if (!isEmpty(child?.backup_internal_tag)) {
              child.internal_tag = { ...child?.backup_internal_tag }
              delete child.backup_internal_tag
            }
            return child
          })
        }
        return item
      })
      return { ...state, workflowItems: workflowTempForRestoreInternalTags }
    case CHANGE_TASK_STATUS:
      //Update task status in workflowItems by currentLineId
      const workflowChangeTaskTemp = [...state.workflowItems]
      const currentIndexAtStatusTask = GetIndexValueFromWorkflowData(workflowChangeTaskTemp, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAtStatusTask?.hasOwnProperty("moduleIndex") && currentIndexAtStatusTask?.hasOwnProperty('taskIndex')) {
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].status = action.payload.status === "skip" ? "skip" : ""
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].skipDate = action.payload.status === "skip" ? new Date() : null
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].isCompleted = false
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].completed_by = ""
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].completedDate = null
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].skipReason = action.payload.status !== "undo_skip" ? action?.payload?.taskSkipReason ?? "" : ""
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].skip_by = action.payload.status === "skip" ? getUserData().username : ""
        if (action.payload.status === "skip") {
          workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].notificationActions = updateNotificationRuleActions((workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].notificationActions || []), "taskskip")
        } else {
          workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex].notificationActions = workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].children[currentIndexAtStatusTask.taskIndex]?.notificationActions.filter((item) => item !== "teskskip")
        }
      } else if (currentIndexAtStatusTask?.hasOwnProperty("moduleIndex")) {
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].status = action.payload.status === "skip" ? "skip" : ""
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].skipDate = action.payload.status === "skip" ? new Date() : null
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].isCompleted = false
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].completed_by = ""
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].completedDate = null
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].skipReason = action.payload.status !== "undo_skip" ? action?.payload?.taskSkipReason ?? "" : ""
        workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].skip_by = action.payload.status === "skip" ? getUserData().username : ""
        if (action.payload.status === "skip") {
          workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].notificationActions = updateNotificationRuleActions((workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].notificationActions || []), "taskskip")
        } else {
          workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex].notificationActions = workflowChangeTaskTemp[currentIndexAtStatusTask.moduleIndex]?.notificationActions?.filter((item) => item !== "taskskip")
        }
      }
      return {
        ...state,
        workflowItems: workflowChangeTaskTemp
      }
    case 'UPDATE_TASK_DURATION':
      //Set duration in parent and child task in workflowItems by currentLineId
      const workDataTaskDuration = [...state.workflowItems]
      const currentIndexTaskDuration = GetIndexValueFromWorkflowData(workDataTaskDuration, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTaskDuration?.hasOwnProperty("moduleIndex") && currentIndexTaskDuration?.hasOwnProperty('taskIndex')) {
        workDataTaskDuration[currentIndexTaskDuration.moduleIndex].children[currentIndexTaskDuration.taskIndex].duration = action.payload.duration ?? ""
      } else if (currentIndexTaskDuration?.hasOwnProperty("moduleIndex")) {
        workDataTaskDuration[currentIndexTaskDuration.moduleIndex].duration = action.payload.duration ?? ""
      }
      return {
        ...state,
        workflowItems: workDataTaskDuration
      }
    case 'ADD_ITEM_COMMENT':
      //Set comment in task workflowItems by currentLineId
      const workDataTaskComments = [...state.workflowItems]
      const currentIndexTaskComment = GetIndexValueFromWorkflowData(workDataTaskComments, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      //set in children task
      if (currentIndexTaskComment?.hasOwnProperty("moduleIndex") && currentIndexTaskComment?.hasOwnProperty('taskIndex')) {
        let comments = workDataTaskComments[currentIndexTaskComment.moduleIndex].children[currentIndexTaskComment.taskIndex].comments
        if (!Array.isArray(comments)) comments = []
        comments.push(action.payload.comment)
        workDataTaskComments[currentIndexTaskComment.moduleIndex].children[currentIndexTaskComment.taskIndex].comments = comments
      } else if (currentIndexTaskComment?.hasOwnProperty("moduleIndex")) {
        //set in parent task
        let comments = workDataTaskComments[currentIndexTaskComment.moduleIndex].comments
        if (!Array.isArray(comments)) comments = []
        comments.push(action.payload.comment)
        workDataTaskComments[currentIndexTaskComment.moduleIndex].comments = comments
      }
      return {
        ...state,
        workflowItems: workDataTaskComments
      }
    case 'WORKFLOW_ITEMS_FOR_CALENDAR':
      let workDataTaskCalendar = [...state.workflowItemForCalendar]
      if (!isEmpty(action?.payload?.workflowTask.dueDate)) {
        if (!isEmpty(workDataTaskCalendar.find(d => d.id === action?.payload?.currentLineId))) {
          workDataTaskCalendar = workDataTaskCalendar.map(item => {
            if (item.id === action?.payload?.currentLineId) {
              if (isEmpty(action?.payload?.workflowTask?.event_id)) {
                action.payload.workflowTask = {
                  ...action?.payload?.workflowTask,
                  event_id: uuidv4(),
                  eventStatus: "new"
                }
              }
              return action?.payload?.workflowTask || {}
            } else return item
          })
        } else {
          if (isEmpty(action?.payload?.workflowTask?.event_id)) {
            action.payload.workflowTask = {
              ...action?.payload?.workflowTask,
              event_id: uuidv4(),
              eventStatus: "new"
            }
          }
          workDataTaskCalendar.push(action?.payload?.workflowTask || {})
        }
      }
      return {
        ...state,
        workflowItemForCalendar: workDataTaskCalendar
      }
    case 'DUE_DATE_AUTO_ADJUST':
      //Set duration in parent and child task in workflowItems by currentLineId
      const workDataTaskDurationv1 = [...state.workflowItems]
      const currentIndexTaskDurationv1 = GetIndexValueFromWorkflowData(workDataTaskDurationv1, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexTaskDurationv1?.hasOwnProperty("moduleIndex") && currentIndexTaskDurationv1?.hasOwnProperty('taskIndex')) {
        workDataTaskDurationv1[currentIndexTaskDurationv1.moduleIndex].children[currentIndexTaskDurationv1.taskIndex].due_date_auto_adjust = action.payload.due_date_auto_adjust ?? false
      } else if (currentIndexTaskDurationv1?.hasOwnProperty("moduleIndex")) {
        workDataTaskDurationv1[currentIndexTaskDurationv1.moduleIndex].due_date_auto_adjust = action.payload.due_date_auto_adjust ?? false
      }
      return {
        ...state,
        workflowItems: workDataTaskDurationv1
      }
    case 'INITIALIZE_WORKFLOW_ITEMS_FOR_CALENDAR':
      return {
        ...state,
        workflowItemForCalendar: []
      }
    case "SET_NOTIFICATION_SETTING_RILE":
      return {
        ...state,
        notificationSettingRules: action.payload
      }
    case "SET_CLICKED_ITEM":
      return {
        ...state,
        clickedItem: action.payload
      }

    //Commented because now it is set from mailDialogue component

    // case "UPDATE_ITEM_MAIL_SUBJECT": {
    //   const workDataTaskMailSubject = [...state.workflowItems]
    //   const currentIndexTaskMailSubject = GetIndexValueFromWorkflowData(workDataTaskMailSubject, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
    //   if (currentIndexTaskMailSubject?.hasOwnProperty("moduleIndex") && currentIndexTaskMailSubject?.hasOwnProperty('taskIndex')) {
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex].newMail = { ...action.payload.mailSubject }
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex].status = "completed"
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex].isCompleted = true
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex].completedDate = new Date()
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex].completed_by = getUserData().username
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex].duration = action.payload.duration ?? ""

    //     const item = workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex]
    //     if (isEmpty(item?.sentMails)) {
    //       workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex].sentMails = [action.payload.mailObject]
    //     } else {
    //       const isMailAlready = item?.sentMails?.find((d) => d.id === action?.payload?.mailObject?.id)
    //       if (isEmpty(isMailAlready)) {
    //         item.sentMails = [...item?.sentMails, action?.payload?.mailObject]
    //       }
    //       workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].children[currentIndexTaskMailSubject.taskIndex] = { ...item }
    //     }
    //   } else if (currentIndexTaskMailSubject?.hasOwnProperty("moduleIndex")) {
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].newMail = { ...action.payload.mailSubject }
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].status = "completed"
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].isCompleted = true
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].completedDate = new Date()
    //     workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].completed_by = getUserData().username
    //     if (isEmpty(workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex]?.sentMails)) {
    //       workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].sentMails = [action.payload.mailObject]
    //     } else {
    //       const isMailAlready = workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex]?.sentMails?.find((d) => d.id === action?.payload?.mailObject?.id)
    //       // if (isEmpty(isMailAlready)) {
    //       //   if (workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex]?.children?.length > 0) {
    //       //     const childTask = workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex]?.children?.find(
    //       //       (d) => d.id === workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].id
    //       //     )
    //       //     if (!isEmpty(childTask)) {
    //       //       isMailAlready = childTask?.sentMails?.find(
    //       //         (d) => d.id === action?.payload?.mailObject?.id
    //       //       )
    //       //     }
    //       //   }
    //       // }
    //       if (isEmpty(isMailAlready)) {
    //         workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex].sentMails = [...workDataTaskMailSubject[currentIndexTaskMailSubject.moduleIndex]?.sentMails, action?.payload?.mailObject]
    //       }
    //     }
    //   }
    //   return {
    //     ...state,
    //     workflowItems: workDataTaskMailSubject
    //   }
    // }

    case "WORKFLOW_ITEM_CHANGED":
      return {
        ...state,
        workflowItemsChanged: action.payload
      }

    case "INFINITE_SCROLL_ITEM":
      //infinite score logic
      let workflowFilterTaskOnly = []
      if (action.payload?.filter && !state?.filteredTask) {
        //Filter task by extension in business workflow
        workflowFilterTaskOnly = (state?.workflowItems).filter(d => JSON.stringify(d.extension) === JSON.stringify(action.payload.filter))
      } else if (action?.payload?.taskFilter && state?.filteredTask) {
        //Filter tasks if advanced search applied
        const filter = action?.payload?.taskFilter
        const filteredBranch = filter.branch ? filter?.branch?.map(i => i?.label).join() : ""
        const filteredCompany = filter.company ? (Array.isArray(filter.company) ? filter.company.map(i => i.label).join() : filter.company) : ""
        const filteredReportTag = filter.report_tag ? (filter.report_tag.label || filter.report_tag) : ""
        const filteredTag = filter.tag ? (filter.tag.label || filter.tag) : ""

        const matches = (obj) => {
          const branchMatch = filter?.branch && obj?.internal_tag?.branch ?
            obj.internal_tag.branch.some(b => filteredBranch.includes(b?.taskTag)) : false
          const companyMatch = filter?.company && obj?.internal_tag?.company ?
            obj.internal_tag.company.some(c => filteredCompany.includes(c?.taskTag)) : false
          const reportTagMatch = filter?.report_tag && obj?.report_tag ?
            Array.isArray(obj.report_tag) ? obj.report_tag.some(rt => rt.name === filteredReportTag) : obj.report_tag.name === filteredReportTag : false
          const tagMatch = filter?.tag && obj?.tag ?
            obj.tag.some(t => t[0] === filteredTag) : false
          return (filteredBranch ? branchMatch : true) && (filteredCompany ? companyMatch : true) && (filteredReportTag ? reportTagMatch : true) && (filteredTag ? tagMatch : true)
        }

        const filterRecursive = (item) => {
          const hasMatch = matches(item)
          const children = Array.isArray(item.children) ? item.children.map(filterRecursive).filter(child => child !== null) : []
          if (hasMatch || children.length > 0) {
            return { ...item, children }
          }
          return null
        }

        workflowFilterTaskOnly = (state?.workflowItems || []).map(filterRecursive).filter(item => item !== null)
      } else {
        //set all task if filter not applied or not in business workflow
        // if (!state?.filteredTask) {
        workflowFilterTaskOnly = state?.workflowItems
        // }
      }
      if (action?.payload?.isOrderChanged) {
        //This required because we don't have update value in item.
        //So default we set 10 if state.items is < 10.
        // Issue where, when you drag children to parent
        //P1
        // P1.1
        // P1.2
        //Next you update like
        //P1.2
        //P1
        //P1.1

        //.slice(0, state?.items.length >= 10 ? state?.items.length : 10)
        const nextItems = workflowFilterTaskOnly?.slice(0, state?.items.length >= 20 ? state?.items.length : 20)
        //nextItems.pop()
        return {
          ...state,
          items: nextItems
        }
      }
      let nextItems = []
      if (action?.payload?.restart) {
        //if in payload have restart true then set items from beginning
        nextItems = workflowFilterTaskOnly?.slice(0, 15000)
        return {
          ...state,
          items: [...nextItems],
          filteredTaskList: workflowFilterTaskOnly
        }
      }
      if (action?.payload?.isCopy) {
        //If task copy then add one more item
        nextItems = workflowFilterTaskOnly?.slice(0, state?.items.length + 1)
        return {
          ...state,
          items: [...nextItems],
          filteredTaskList: workflowFilterTaskOnly
        }
      }
      nextItems = workflowFilterTaskOnly?.slice(state?.items.length, state?.items.length + 10)
      return {
        ...state,
        items: [...state?.items, ...nextItems],
        filteredTaskList: workflowFilterTaskOnly
      }
    case "SELECTED_TASK_FOR_MAIL_SENT": {
      return {
        ...state,
        selectedTaskForMailSent: action?.payload || ""
      }
    }
    case "SELECTED_MAIL_MERGE_TEMPLATE_ID": {
      return {
        ...state,
        mailMergeTemplateId: action?.payload || ""
      }
    }
    case "CLEAR_INFINITE_ITEM":
      return {
        ...state,
        items: []
      }
    case "SET_FILTER":
      return {
        ...state,
        filteredTask: action?.payload
      }
    case "EDIT_WORK_FLOW_DATA_CHILD":
      const workflowDataTagTemp2 = [...state.workflowItems]
      const currentIndexAtTag2 = GetIndexValueFromWorkflowData(workflowDataTagTemp2, action.payload.currentLineId, state.selectedFilterType?.value ?? null)
      if (currentIndexAtTag2?.hasOwnProperty("moduleIndex") && currentIndexAtTag2?.hasOwnProperty('taskIndex')) {
        workflowDataTagTemp2[currentIndexAtTag2.moduleIndex].children[currentIndexAtTag2.taskIndex].comment_status = action.payload.comment_status
      } else if (currentIndexAtTag2?.hasOwnProperty("moduleIndex")) {
        workflowDataTagTemp2[currentIndexAtTag2.moduleIndex].comment_status = action.payload.comment_status
      }
      return {
        ...state,
        workflowItems: workflowDataTagTemp2
      }
    case 'SORT_WORKFLOW_ITEMS_POSITION':
      /**
       * Sorts workflow items based on their status and completion state.
       * @returns {Array} Sorted workflow items with completed tasks first, followed by incomplete ones, ordered by their status.
       */
      const workflowItemsSortedNew = [...state.items].sort((a, b) => {
        const isFinished = (item) => {
          const isSkip = (item.status === 'skip' || !!item.skipDate)
          return item?.isCompleted || isSkip
        }

        const getGroupPriority = (status) => {
          if (status === 'completed' || status === 'complete' || status === 'skip') {
            return 0
          }
          return 1 // Everything else (pending, etc.)
        }
        const priorityComparison = getGroupPriority(a.status) - getGroupPriority(b.status)
        if (priorityComparison !== 0) return priorityComparison

        // 2. Tertiary Sort: Combined Date (Older at the top)
        const getDateValue = (item) => {
          if (!isFinished(item)) return Infinity
          // This picks the available date regardless of status
          const dateStr = item.completedDate || item.skipDate
          return dateStr ? new Date(dateStr).getTime() : Infinity
        }

        const dateA = getDateValue(a)
        const dateB = getDateValue(b)

        return dateA - dateB
      })
      return {
        ...state,
        items: workflowItemsSortedNew,
      }   
    default:
      return state
  }
}

export default workflowEditorReducer
